import { handleActions } from 'redux-actions';
import { State } from './model';

const Reducer = handleActions({
  // common
  'appointmentUserFiles/DOWNLOAD_REQUEST': (state, { payload }) => {
    return state.setIn(['isDownloading'], true)
                .setIn(['errMsg'], null);
  },
  'appointmentUserFiles/DOWNLOAD_SUCCESS': (state, { payload }) => {
    return state.setIn(['isDownloading'], false)
                .setIn(['errMsg'], null);
  },
  'appointmentUserFiles/DOWNLOAD_FAILURE': (state, { payload }) => {
    return state.setIn(['isDownloading'], false)
                .setIn(['errMsg'], payload.errMsg);
  },
  'appointmentUserFiles/POST_REQUEST': (state, { payload }) => {
    return state.setIn(['isPosting'], true)
                .setIn(['errMsg'], null);
  },
  'appointmentUserFiles/POST_SUCCESS': (state, { payload }) => {
    return state.setIn(['isPosting'], false)
                .setIn(['errMsg'], null);
  },
  'appointmentUserFiles/POST_FAILURE': (state, { payload }) => {
    return state.setIn(['isPosting'], false)
                .setIn(['errMsg'], payload.errMsg);
  },
  'appointmentUserFiles/GET_REQUEST': (state, { payload }) => {
    return state.setIn(['isGetting'], true)
                .setIn(['errMsg'], null);
  },
  'appointmentUserFiles/GET_SUCCESS': (state, { payload }) => {
    return state.setIn(['isGetting'], false)
                .setIn(['errMsg'], null);
  },
  'appointmentUserFiles/GET_FAILURE': (state, { payload }) => {
    return state.setIn(['isGetting'], false)
                .setIn(['errMsg'], payload.errMsg);
  },
  'appointmentUserFiles/PUT_REQUEST': (state, { payload }) => {
    return state.setIn(['isPutting'], true)
                .setIn(['errMsg'], null);
  },
  'appointmentUserFiles/PUT_SUCCESS': (state, { payload }) => {
    return state.setIn(['isPutting'], false)
                .setIn(['errMsg'], null);
  },
  'appointmentUserFiles/PUT_FAILURE': (state, { payload }) => {
    return state.setIn(['isPutting'], false)
                .setIn(['errMsg'], payload.errMsg);
  },
  'appointmentUserFiles/DELETE_REQUEST': (state, { payload }) => {
    return state.setIn(['isDeleting'], true)
                .setIn(['errMsg'], null);
  },
  'appointmentUserFiles/DELETE_SUCCESS': (state, { payload }) => {
    return state.setIn(['isDeleting'], false)
                .setIn(['errMsg'], null);
  },
  'appointmentUserFiles/DELETE_FAILURE': (state, { payload }) => {
    return state.setIn(['isDeleting'], false)
                .setIn(['errMsg'], payload.errMsg);
  },
  'appointmentUserFiles/BACKUP_REQUEST': (state, { payload }) => {
    return state.setIn(['isBackuping'], true)
                .setIn(['errMsg'], null);
  },
  'appointmentUserFiles/BACKUP_SUCCESS': (state, { payload }) => {
    return state.setIn(['isBackuping'], false)
                .setIn(['errMsg'], null);
  },
  'appointmentUserFiles/BACKUP_FAILURE': (state, { payload }) => {
    return state.setIn(['isBackuping'], false)
                .setIn(['errMsg'], payload.errMsg);
  },
  'attachment/UPDATE_IS_EXCEEDED_QUOTA': (state, { payload }) => {
    return state.setIn(['isExceededQuota'], payload);
  },
}, State);

export default Reducer;